import { OverlappingAppointmentsConfigurationForm } from './form/OverlappingAppointmentsConfigurationForm';
import { OverlappingAppointmentsConfigurationFormLoader } from './form/OverlappingAppointmentsConfigurationForm.loader';

export const CalendarSettings = (): JSX.Element => {
   return (
      <OverlappingAppointmentsConfigurationFormLoader>
         {({ appointmentConfiguration }) => (
            <OverlappingAppointmentsConfigurationForm
               overlappingAppointmentsAllowed={appointmentConfiguration.overlappingAppointmentsAllowed}
            />
         )}
      </OverlappingAppointmentsConfigurationFormLoader>
   );
};
